import {Component, OnDestroy, OnInit} from '@angular/core';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {RegionModel} from '../../../../models/RegionModel';
import {ProviderModel} from '../../../../models/ProviderModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ReimbursmentModel} from '../../../../models/ReimbursmentModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {ReimbursmentService} from '../service-reimbursment/reimbursment.service';
import * as toastr from 'toastr';
import {ServiceVariantModel} from 'src/models/ServiceVariantModel';

@Component({
  selector: 'app-edit-reimbursment',
  templateUrl: './edit-reimbursment.component.html',
  styleUrls: ['./edit-reimbursment.component.scss']
})
export class EditReimbursmentComponent extends BaseGeneralComponent implements OnInit, OnDestroy {
  showActions: boolean;

  reimbursment: ReimbursmentModel;
  providerSelect: ProviderModel;
  regionSelect: RegionModel;
  localCustomerSelect: LocalCustomerModel;
  resourceUnitSelect: ServiceVariantModel;
  currencySelect: CurrencyModel;
  compensationPaymentSelect: number;

  selected: string;
  savereimbursment: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  reimbursmentJson: any;

  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private reimbursmentService: ReimbursmentService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();


    this.reimbursment = new ReimbursmentModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.providerSelect = new ProviderModel();
    this.resourceUnitSelect = new ServiceVariantModel();
    this.currencySelect = new CurrencyModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.reimbursmentJson = params['row'];
        this.reimbursment = JSON.parse(this.reimbursmentJson) as ReimbursmentModel;
        this.localCustomerSelect = this.reimbursment.localCustomer;
        this.regionSelect = this.reimbursment.region;
        this.providerSelect = this.reimbursment.provider;
        this.resourceUnitSelect = this.reimbursment.serviceVariant;
        this.currencySelect = this.reimbursment.currency;
        this.compensationPaymentSelect = this.reimbursment.compensationPayment
      });


    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      currency: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      compensationPayment: [{value: '', disabled: false}, Validators.required]

    });

    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });

    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });

    this.registerForm.patchValue({
      currency: this.currencySelect.cod
    });

    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect.cod
    });

    this.registerForm.patchValue({
      compensationPayment: this.compensationPaymentSelect
    });

  }
  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.reimbursment.compensationPayment = this.registerForm.value.compensationPayment;
      this.savereimbursment = this.reimbursmentService.update(this.reimbursmentService.baseUrl, this.reimbursment)
        .subscribe(
          (result: any) => {
            toastr.success('Reimbursment element was edited with success', 'Success');
            this.loaderService.display(false);
            this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
          },
          error => {
            toastr.error('Reimbursment element was not edited', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  ngOnDestroy(): void {
    if (this.savereimbursment) {
      this.savereimbursment.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }
/*
  getElementSelectedLC($event) {
    this.reimbursment.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedRegion($event) {
    this.reimbursment.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  getElementSelectedProvider($event) {
    this.reimbursment.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
  }

  getElementSelectedContractType($event) {
    this.reimbursment.contractType = $event.row;
    this.contractTypeSelect = $event.row;
    this.registerForm.patchValue({
      contractType: this.contractTypeSelect.cod
    });
  }

  getElementSelectedResourceUnit($event) {
    this.reimbursment.resourceUnit = $event.row;
    this.resourceUnitSelect = $event.row;
    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect.cod
    });
  }

  getElementSelectedCurrency($event) {
    this.reimbursment.currency = $event.row;
    this.currencySelect = $event.row;
    this.registerForm.patchValue({
      currency: this.currencySelect.cod
    });
  }
*/

  handle(value) {
    this.reimbursment.compensationPayment = value;
    this.registerForm.patchValue({
      compensationPayment: value
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


}
